import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './terms-of-service.component.html'
})
export class TermsOfServiceComponent implements OnInit {

  isLoggedIn: boolean;

  title = [
    '_TERMS_OF_SERVICE.TITLE_1',
    '_TERMS_OF_SERVICE.TITLE_2'
  ];

  content = '_TERMS_OF_SERVICE.CONTENT';

  constructor(private authService: AuthService) {
    this.authService.currentUser.subscribe(currentUser => this.isLoggedIn = !!(currentUser) );
  }

  ngOnInit() {}

}
